import { gql } from '@apollo/client';
import {SelectOptionType, SELECT_OPTION_FIELDS} from 'graphql/types/SelectOptionType'

export const GET_ALL_SETTLEMENT_CLIENT_FOR_OPTIONS = gql`
    query SettlementClientQuery($roleType: Int) {
        allOptions: getAllSettlementClient(roleType: $roleType) {
            ...SelectOptionFields
        }
    }
    ${SELECT_OPTION_FIELDS}
`;

export interface AllSettlementClientResponse {
    allOptions: SelectOptionType[];
}
